<template>
  <div :class="classes" v-loading="loading">
      <pt-page-title title="系统用户" isSearch  @search="search" @emptySearch="emptySearch" placeholder="请填写用户姓名搜索" :searchKey="searchKey" @searchNo="searchNo" isParams>
          <template slot="before-left">
              <el-button type="primary" @click="createCustomer">新建用户</el-button>
          </template>
      </pt-page-title>
      <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <!-- <el-button type="primary" @click="Filter()">筛选</el-button> -->
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-system-customer-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" :class="$style['pt-system-customer-table']" ref="table" :paramsData="paramsData">
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="goDetail(scope.row.userLogin)">详情</el-button>
                <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
              </template>
          </el-table-column>
      </pt-system-customer-table>
  </div>
</template>

<script>
// 组件class前缀
import { systemTableFilter, systemTableLabels } from './system-customer-option'
import ptSystemCustomerTable from './pt-customer-of-system-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-customer-of-system'
export default {
  name: 'pt-customer-of-system',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptSystemCustomerTable
  },
  props: {
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      filterLabels: systemTableFilter,
      tableLabels: systemTableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: null,
      loading: false
    }
  },
  watch: {
    rolesList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'role') {
            item.options = val
          }
        })
      }
    },
    params: {
      handler: function (val) {
        this.Filter()
      }
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = { searchKey: val }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    searchNo (val) {
      this.searchKey = val
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      console.log('this.isFromRouter', this.isFromRouter)
      this.paramsData = { ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    },
    editCustomer (val) {
      this.$router.push('/system-customer-form/true/' + val.userLogin)
    },
    goDetail (userLogin) {
      this.$router.push(`/system-user-detail/${userLogin}`)
    },
    createCustomer () {
      this.$router.push('/system-customer-form/false/0')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-system-customer-table{
    :global
  .iconfont{
        margin-right: 10px;
    }
}

</style>
